import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useParams } from 'react-router-dom'
import { masterclassService } from '../../services/masterclassService'
import { SCHEDULE_SERIES_NAME } from '../../utils/masterclassSchedule'

const BASE_URL = 'https://www.synergymultimedia.co.ug'

export default function SpeakerSchema() {
  const { id } = useParams()
  const [speaker, setSpeaker] = useState(null)

  useEffect(() => {
    if (!id) return
    let mounted = true
    masterclassService.getSpeaker(id)
      .then((res) => { if (mounted && res.speaker) setSpeaker(res.speaker) })
      .catch(() => {})
    return () => { mounted = false }
  }, [id])

  if (!speaker) return null

  const url = `${BASE_URL}/masterclass/speakers/${speaker.slug || speaker.id}`
  const image = speaker.photo_url || `${BASE_URL}/Logos/SMA%20LOGO%20%20DARK%20MODE.png`
  const title = `${speaker.name} | SMA Masterclass Speaker`
  const description = speaker.bio
    ? `${speaker.bio.substring(0, 150)}${speaker.bio.length > 150 ? '...' : ''}`
    : `Learn from ${speaker.name} at Synergy Multimedia Academy ${SCHEDULE_SERIES_NAME}.`

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: speaker.name,
    jobTitle: speaker.title,
    worksFor: speaker.company ? { '@type': 'Organization', name: speaker.company } : undefined,
    description: speaker.bio,
    image,
    url,
    sameAs: [
      speaker.website_url,
      speaker.linkedin_url,
      speaker.instagram_url,
      speaker.twitter_url,
      speaker.facebook_url,
    ].filter(Boolean),
    knowsAbout: speaker.specialization ? [speaker.specialization] : undefined,
  }

  if (!schema.worksFor) delete schema.worksFor
  if (!schema.knowsAbout) delete schema.knowsAbout

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="profile" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Synergy Multimedia Academy" />
      <meta property="profile:first_name" content={speaker.name?.split(' ')[0]} />
      <meta property="profile:last_name" content={speaker.name?.split(' ').slice(1).join(' ')} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  )
}
